import React from "react";
import { TATVA_PHOTO_WYNN_B64 } from "../lib/tatvaPhotoWynn";
import { WynnCoverSheet as _Base } from "./CoverLetterWynn"; // unused, kept for parity
void _Base;

/** Wynn — Head of Stage · Entertainment (cover letter). */

const CREAM = "#f4ede0";
const INK = "#1a1a1a";
const INK_SOFT = "#3a342b";
const BRONZE = "#8a6f47";
const RULE_SOFT = "rgba(26,26,26,0.10)";
const SERIF = '"Playfair Display", Georgia, "Times New Roman", serif';
const SANS = "Inter, -apple-system, BlinkMacSystemFont, sans-serif";

const Eyebrow = ({ children }) => (
    <p style={{ fontFamily: SANS, color: BRONZE, fontSize: 9, letterSpacing: "0.36em", textTransform: "uppercase", fontWeight: 600, margin: 0 }}>
        {children}
    </p>
);

export const WynnStageCoverSheet = () => (
    <article className="cover-page" data-testid="cover-letter-sheet"
        style={{ width: 794, height: 1120, maxWidth: "100%", margin: "0 auto", backgroundColor: CREAM, color: INK, boxShadow: "0 24px 60px rgba(0,0,0,0.18), 0 0 0 1px rgba(26,26,26,0.06)", padding: "56px 80px 44px", boxSizing: "border-box", position: "relative", fontFamily: SANS, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 22, paddingBottom: 18, borderBottom: `1px solid ${RULE_SOFT}`, marginBottom: 26 }}>
            <div style={{ flex: 1 }}>
                <h1 style={{ fontFamily: SERIF, fontSize: 32, fontWeight: 500, color: INK, margin: 0, letterSpacing: "-0.02em", lineHeight: 1 }}>Aditya Anand</h1>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 12, color: BRONZE, margin: "4px 0 0" }}>
                    Known professionally as Tatva K
                </p>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 12, color: INK_SOFT, margin: "6px 0 0" }}>
                    Live AV Production &middot; Sound Engineer &middot; Broadcast Producer
                </p>
                <p style={{ fontFamily: SANS, fontSize: 9.5, color: INK_SOFT, margin: "10px 0 0", letterSpacing: "0.04em", lineHeight: 1.55 }}>
                    Al Hamra Village, Ras Al Khaimah, UAE
                    <br />
                    tatvak@theresetsanctuary.org &middot; +971 50 676 9007
                </p>
            </div>
            <img src={TATVA_PHOTO_WYNN_B64} alt="Tatva K" style={{ width: 92, height: 110, objectFit: "cover", border: `1px solid rgba(26,26,26,0.18)`, flexShrink: 0 }} />
        </header>

        <div style={{ fontFamily: SANS, fontSize: 9.5, color: BRONZE, letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600, margin: "0 0 22px" }}>
            Re: Head of Stage &mdash; Entertainment
        </div>

        <section style={{ fontFamily: SERIF, fontSize: 12, lineHeight: 1.6, color: INK_SOFT, fontWeight: 400 }}>
            <p style={{ margin: "0 0 11px" }}>Dear hiring team,</p>

            <p style={{ margin: "0 0 11px" }}>
                I am writing to apply for the <strong style={{ color: INK }}>Head of Stage &mdash; Entertainment</strong>{" "}
                position at Wynn Al Marjan Island. I am a UAE resident based in Al Hamra Village, Ras Al Khaimah,
                available on-site immediately and prepared to commit fully to the pre-opening team.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                Stage is where I have spent most of my professional life. I performed on the{" "}
                <strong style={{ color: INK }}>Sunburn Festival mainstage from 2006 through 2009</strong> alongside Armin
                van Buuren and Defected Records artists &mdash; four consecutive years of large-format live shows in
                front of audiences exceeding fifty thousand. I know the stage as an artist, which means I understand
                exactly what stage management has to deliver for the performance to land.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                Beyond the festival circuit, I have performed and produced across India&rsquo;s superclub network
                (Plethora, Elevate, MTV Flyp Delhi, Playboy Club) and led the stage execution of high-end private
                productions at Mehrangarh Fort, Udaipur Palace and many destination weddings for Indian HNWI clientele.
                These environments require quiet authority, fast troubleshooting, and tight coordination between
                performers, lighting, sound and creative direction &mdash; the daily fabric of the role you are hiring
                for.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                I was also <strong style={{ color: INK }}>Producer, DJ and RJ on Zabardast Hit 95&nbsp;FM</strong> for
                thirteen years &mdash; a triple role inside a national flagship broadcast that taught me uptime as a
                daily discipline and cross-team coordination as a default working style.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                As Founder of Chill Om Records &amp; Studios and Founder of The Reset Sanctuary in the UAE, I have led
                teams, managed equipment lifecycles, and built the operational rhythm that mission-critical stage
                operations demand. I am Berklee-trained, and an Ableton
                Live user since 2004 with engineered credits totalling over 200 million streams and views.
            </p>

            <p style={{ margin: "0 0 11px" }}>
                I would welcome the opportunity to discuss how my stage experience can serve the Entertainment Technical
                Services team at Wynn Al Marjan Island. I am happy to meet on-site at your convenience.
            </p>

            <p style={{ margin: 0 }}>Thank you for your time and consideration.</p>
        </section>

        <div style={{ marginTop: "auto", paddingTop: 22, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
            <div>
                <p style={{ fontFamily: SERIF, fontStyle: "italic", fontSize: 22, color: INK, margin: 0, letterSpacing: "-0.01em", lineHeight: 1 }}>Warm regards,</p>
                <p style={{ fontFamily: SERIF, fontSize: 20, color: BRONZE, margin: "8px 0 0", fontWeight: 500, letterSpacing: "-0.01em" }}>Tatva K</p>
            </div>
            <div style={{ textAlign: "right" }}>
                <Eyebrow>Entertainment &middot; Head of Stage</Eyebrow>
                <p style={{ fontFamily: SANS, fontSize: 9.5, color: INK_SOFT, margin: "8px 0 0", letterSpacing: "0.04em", lineHeight: 1.6 }}>
                    UAE Resident &middot; On-site Ready
                </p>
            </div>
        </div>
    </article>
);
